import React from 'react';
import { Route, Redirect} from 'react-router-dom';
import Aside from '../Components/Includes/Aside.js';
import Nav from '../Components/Includes/Nav';
import Footer from '../Components/Includes/Footer';
export const PrivateRoute = ({component: Component,...rest}) => {
    /*get login status */
    const loginStatus = JSON.parse(window.localStorage.getItem('loginStatus'));
    return(
        <Route {...rest} render={(props) =>(
            loginStatus ? (
                <div>
                    <div id="wrapper">
                        <Aside/>
                        <div id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <Nav/>
                                <div className="container-fluid">
                                    <Component {...props} />
                                </div>
                            </div>
                            <Footer/>
                        </div>  
                    </div>  
                    <a className="scroll-to-top rounded" href="#page-top">
                        <i className="fas fa-angle-up"></i>
                    </a>  

                    <div className="modal fade" id="logoutModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
                            <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            </div>
                            <div className="modal-body">Select "Logout" below if you are ready to end your current session.</div>
                            <div className="modal-footer">
                            <button className="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
                            <a className="btn btn-primary" href="login.html">Logout</a>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>   
            ):(
                <Redirect to={{pathname:"/login", state:{from: props.location}}}/>
            )
        )} />
    )
}

export default PrivateRoute;
